"use client";
import { callAll as r, isString as o } from "./misc.js";
const c = (...n) => n.map((e) => e?.trim?.()).filter(Boolean).join(" "), l = /((?:--)?(?:\w+-?)+)\s*:\s*([^;]*)/g, s = (n) => {
  const e = {};
  let i;
  for (; i = l.exec(n); )
    e[i[1]] = i[2];
  return e;
}, f = (n, e) => {
  if (o(n)) {
    if (o(e)) return `${n};${e}`;
    n = s(n);
  } else o(e) && (e = s(e));
  return Object.assign({}, n ?? {}, e ?? {});
};
function p(...n) {
  let e = {};
  for (let i of n) {
    for (let t in e) {
      if (t.startsWith("on") && typeof e[t] == "function" && typeof i[t] == "function") {
        e[t] = r(i[t], e[t]);
        continue;
      }
      if (t === "className" || t === "class") {
        e[t] = c(e[t], i[t]);
        continue;
      }
      if (t === "style") {
        e[t] = f(e[t], i[t]);
        continue;
      }
      e[t] = i[t] !== void 0 ? i[t] : e[t];
    }
    for (let t in i)
      e[t] === void 0 && (e[t] = i[t]);
  }
  return e;
}
export {
  p as mergeProps
};
